import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

document.addEventListener('DOMContentLoaded', () => {
	GLightbox({
		selector: 'section.gallery a',
	});
});
